// Google Analytics utility functions
export const GA_TRACKING_ID = 'G-ZXZMGWGGJT';

// Initialize Google Analytics
export const initGA = () => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_TRACKING_ID, {
      page_title: document.title,
      page_location: window.location.href,
    });
  }
};

// Track page views
export const trackPageView = (url) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_TRACKING_ID, {
      page_path: url,
    });
  }
};

// Track custom events
export const trackEvent = (action, category, label, value) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Track gallery interactions
export const trackGalleryView = (photoId, photoTitle) => {
  trackEvent('gallery_view', 'engagement', photoTitle, photoId);
};

// Track achievement clicks
export const trackAchievementClick = (achievementTitle) => {
  trackEvent('achievement_click', 'engagement', achievementTitle);
};

// Track contact form submissions
export const trackContactSubmit = (subject) => {
  trackEvent('contact_submit', 'engagement', subject);
};

// Track social media clicks
export const trackSocialClick = (platform) => {
  trackEvent('social_click', 'engagement', platform);
};
